/**
 * The Last results card's data (specs/home-page AC-39, AC-40): the Arena's finished-preview query
 * (newest COMPLETED challenges, already fetched for the Arena strip) reduced to the two latest 1v1s.
 */

import { useMemo } from 'react';
import { useSupabaseAuth } from '../../shared/contexts/SupabaseAuthContext';
import { useChallengesHistoryPreviewQuery } from '../../challenges/hooks/useChallengesQuery';
import { selectLastResults } from '../helpers/homeLastResults.helper';
import type { HomeResultTileModel } from '../types/home.types';

export interface UseHomeLastResultsReturn {
  results: HomeResultTileModel[];
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export const useHomeLastResults = (): UseHomeLastResultsReturn => {
  const { userId } = useSupabaseAuth();
  const query = useChallengesHistoryPreviewQuery(userId ?? null, !!userId);
  const challenges = query.data;

  const results = useMemo(
    () => (userId && challenges ? selectLastResults(challenges, userId) : []),
    [challenges, userId],
  );

  return {
    results,
    isLoading: query.isPending,
    isError: query.isError,
    refetch: () => {
      void query.refetch();
    },
  };
};
